import React from 'react';
import { Link } from 'gatsby';
import '../styles/navBarTop-styles.css';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import Search from "../components/search";

const NavbarTop = ({ data, menuItems, interior }) => {

    return (

    <Container fluid className={`top-nav ${interior ? 'interior' : ''}`}>
        <Container>
            <Row className="main-nav">
                <nav>
                {menuItems
                        .filter((menuItem) =>
                            menuItem.navLocation.includes("Top Bar Navigation")
                        )
                        .sort((a, b) => a.navOrder - b.navOrder) 
                        .map((menuItem, index, array) => {
                            // Ensure navOrder is within the range 1-5
                            const navOrder = Math.max(1, Math.min(index + 1, 5));
                            // {menuItems.map((menuItem, index, array) => {
                            //     if (menuItem.navLocation.includes('Top Bar Navigation')) {
                            return (
                                <Col key={menuItem.navGroupName} className={`main-nav-item ${index === array.length - 1 ? 'last-item' : ''}`}>
                                    {menuItem.navUrl ? (
                                        <a href={menuItem.navUrl} rel="noopener noreferrer">
                                            <FontAwesomeIcon icon={faLock} />
                                            {menuItem.navGroupName}
                                        </a>
                                    ) : (
                                        <>
                                            <Link to={`/${menuItem.navSlug}`}>
                                                {menuItem.navGroupName === "SEARCH" ? <FontAwesomeIcon className="search-icon" icon={faMagnifyingGlass} /> : menuItem.navGroupName}
                                            </Link>
                                            {/* {renderNavNextLevel(menuItem.navNextLevel, `/${menuItem.navSlug}`)} */}
                                        </>
                                    )}
                                </Col>
                            );
                        }
                        )}
                </nav>
            </Row>
        </Container>
    </Container>
    
  
)};

export default NavbarTop;